<template>
    <div class="collate-title-bar clearfix">
        <span class="collate-title">起盘</span>
        <div class="collate-type">
            <span class="cur">输入时间</span>
            <span @click="clickAdvanced('sizhu')">四柱</span>
            <!-- <span class="hide">万年历</span> -->
        </div>
    </div>
</template>

<script>
import { DOM } from '../../modules/dom'
export default {
    name: 'CollateTitleBar',
    methods:{
        clickAdvanced(type) {
            if(type == 'sizhu') {
                window._czc.push(["_trackEvent", "起盘模块", "起盘", "点击四柱"]);
            }
            this.$store.dispatch('collate/initSizhuCollate');
            this.$router.replace('/collate/advancedcollate');
            DOM.hidePageByClassName('collate-page');
        }
    }
}
</script>